// @flow
/**
 * @module Sagas/PublicAccountPages/InitialRequest
 * @desc Public Account Pages - Initial Request related sagas
 */

import { all, call, put, takeLatest } from "redux-saga/effects";
import * as PublicAccountPagesConstants from "../../Constants/PublicAccountPages/publicAccountPagesConstants";
import * as api from "../../Api/PublicAccountPages/initialrequest";

/**
 * Initial Requests
 */
export function* initialRequestFormSubmit(action: Object): Object {
  const { formElements } = action.payload;
  try {
    const response = yield call(api.submitInitialRequestForm(formElements));
    console.log(response.status);
    const { status } = response;
    if (status === 201) {
      yield put({
        type: PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_SUCCESS
      });
    } else {
      yield put({
        type: PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_FAILURE
      });
    }
  } catch (err) {
    yield put({
      type: PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_FAILURE
    });
  }
}

/**
 * Initial Requests Sagas Connector
 */
export default function* root(): Object {
  yield all([
    takeLatest(PublicAccountPagesConstants.INITIAL_REQUEST_FORM_SUBMIT_REQUEST, initialRequestFormSubmit)
  ])
}



// WEBPACK FOOTER //
// ./src/Sagas/PublicAccountPages/initialrequest.js